import React from 'react';

const STATUS_CLASS = {
  added: 'migration-status --added',
  skipped: 'migration-status --skipped',
  failed: 'migration-status --failed',
};

const ImportSummary = ({ title, results, columns }) => {
  if (!results || results.length === 0) {
    return null;
  }

  const counts = results.reduce(
    (acc, item) => {
      acc[item.status] = (acc[item.status] || 0) + 1;
      return acc;
    },
    { added: 0, skipped: 0, failed: 0 },
  );

  return (
    <section className="widget full-width form-table migration-summary">
      <header>
        <h3>{title}</h3>
        <div className="actions">
          <span className="migration-status --added">
            Added: {counts.added}
          </span>
          <span className="migration-status --skipped">
            Skipped: {counts.skipped}
          </span>
          <span className="migration-status --failed">
            Failed: {counts.failed}
          </span>
        </div>
      </header>
      <main>
        <div className="form-content scrollable">
          <table>
            <thead>
              <tr>
                <th>Row</th>
                {columns.map((column) => (
                  <th key={column.key}>{column.label}</th>
                ))}
                <th>Status</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {results.map((item, index) => (
                <tr key={`${item.row}-${index}`}>
                  <td>{item.row}</td>
                  {columns.map((column) => (
                    <td key={column.key}>{item.data[column.key] || '-'}</td>
                  ))}
                  <td>
                    <span className={STATUS_CLASS[item.status]}>
                      {item.status}
                    </span>
                  </td>
                  <td>{item.message || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
    </section>
  );
};

export { ImportSummary };
